  
  <div *ngIf="alert && caseCreateIsFailed" class="alertMessage" class="alert alert-danger alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" role="alert">
    <p>{{errorMessage}}</p>
  </div>
    <ng-template #content let-modal >
  <div class="sticky">{{caseUiTitle}}
    <button style="float: right;cursor: pointer;
    color: white;background-color: transparent;
   border: transparent;font-weight: bolder; padding-right: 20px; font-size:19px;" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="alert alertMessage" *ngIf="caseOfficeTime==false" [innerHTML]="caseMessage" >
  </div>
  <div *ngIf="caseOfficeTime== true">
  <div class="modal-body" style="height:auto;"  *ngIf="caseCreationSuccess">

    <div class="success_msg" *ngIf="caseCreationSuccess">
      <div  class="alert alertMessage">
        {{alertMessage}}
      </div>
      </div>
  </div>
  <div class="modal-body"  *ngIf="!caseCreationSuccess">
    <form #caseform="ngForm" class="form_class"  *ngIf="this.fieldTypes && this.ticketFields && !caseCreationSuccess">
      <div class="fieldName" style="color:dodgerblue">{{this.caseWelcomeNote}}</div>
      <div *ngIf="!loggedIn">
        <br>
      <div class="form-group"  *ngFor="let ticketField of ticketFields.userFieldsConfiguration">
        <label for="{{ticketField.fieldName}}" class="fieldName">{{ticketField.displayName}}:<span class="sp" *ngIf="ticketField.required">*</span></label>
        <div class="input-group">
        <input class="form-control" type="text"  id="{{ticketField.fieldName}}" #unauthenticatedFields="ngModel" [(ngModel)]="ticketField.runTimeVariableValue" value="ticketField.runTimeVariableValue" name="{{ticketField.fieldName}}" 
               [required]="ticketField.required" pattern="{{ticketField.validationRule}}"
               maxlength="{{ticketField.maxLength}}"/>
        </div>
          <div *ngIf="unauthenticatedFields.errors && (unauthenticatedFields.invalid || unauthenticatedFields.touched)"> 
            <small class="validation_style" 
             *ngIf="unauthenticatedFields.errors.required && unauthenticatedFields.touched && ticketField.required">{{ticketField.displayName}} is required</small> 
          <small class="validation_style" *ngIf="unauthenticatedFields.errors.pattern">{{ticketField.ruleValidationMsg}}</small>
           </div> 
      </div>
    </div>
      <div *ngFor="let fieldType of sortBy('fieldOrder')" class="form-group">
        <div class="form-group" *ngIf="fieldType.type==='DATE' && !fieldType.hidden">
        <label for="DATE_{{fieldType.id}}"class="fieldName">{{fieldType.name}}</label><span class="sp" *ngIf="fieldType.required && !fieldType.hidden">*</span>
        <div class="input-group">
          <input  class="form-control" type="text" [required]="fieldType.required && !fieldType.hidden" id="{{fieldType.id}}" [(ngModel)]="fieldType.value" value="fieldType.value" name="{{fieldType.id}}" [maxDate]="maxDate" [minDate]="minDate"  ngbDatepicker="ngModel" #datepicker="ngbDatepicker"> 
           <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()" type="button"><i class="fa fa-calendar"></i></button>
          </div> 
          <div>
            <small class="validation_style" 
             *ngIf="datepicker.touched && fieldType.required">{{fieldType.name}} is required</small>
          </div>
        </div>
      </div>

        <div class="form-group" *ngIf="fieldType.type==='INTEGER'&& !fieldType.hidden">
          <label for="integer" class="fieldName">{{fieldType.name}}</label><span class="sp"
            *ngIf="fieldType.required">*</span>
          <div class="input-group">
            <input id="integer" #integerField="ngModel" name="integer" (blur)="checkStatus(null)"
              (focus)="checkStatus(fieldType.id)" maxlength="1000" [required]="fieldType.required && !fieldType.hidden"
              (keypress)="onKeypressEvent($event,this)" minlength="-2147483648" maxlength="2147483647"
              [(ngModel)]=fieldType.value value="fieldType.value" type="number" class="form-control" required />
          </div>
          <div class="validation_style" *ngIf="integerField.touched && !integerField.valid && fieldType.required">
            {{fieldType.name}} is required</div>
        </div>
        <div class="form-group"  *ngIf="fieldType.type==='EMAIL' && !fieldType.hidden">
          <label for="email" class="fieldName">{{fieldType.name}}</label><span class="sp"
            *ngIf="fieldType.required">*</span>
          <div class="input-group">
            <input id="email" type="text" [required]="fieldType.required && !fieldType.hidden" #email="ngModel" name="email"
            maxlength="200" (blur)="checkStatus(null)" (focus)="checkStatus(fieldType.id)" [(ngModel)]=fieldType.value
            pattern="^((\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*\s*\,\s*)*(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*))$" value="fieldType.value"  class="form-control" (change)="validEmail($event.target.value)" required  multiple/> </div>
              <div><span style="float:left" class="fieldName">
                (separate with ',')</span><span style="float:right" class="fieldName">Maximum 200 characters</span>
              </div><br>
              <div *ngIf="email.errors && (email.invalid || email.touched)">
                <small class="validation_style" 
                 *ngIf="email.errors.required && email.touched && fieldType.required">{{fieldType.name}} is required</small>
                <small class="validation_style" *ngIf="email.errors.pattern">{{fieldType.name}} is invalid</small>
              </div>
        </div>

        <div class="form-group" *ngIf="fieldType.type==='STRING' && !fieldType.hidden">
          <label for="strings" class="fieldName">{{fieldType.name}}</label><span class="sp"
            *ngIf="fieldType.required">*</span>
          <div class="input-group">
            <input [required]="fieldType.required && !fieldType.hidden" id="{{fieldType.id}}" #stringField="ngModel"
              name="{{fieldType.id}}" value="fieldType.value" [(ngModel)]="fieldType.value" (blur)="checkStatus(null)"
              (focus)="checkStatus(fieldType.id)" maxlength="1000" type="text" class="form-control" required />
          </div>
          <div class="validation_style" *ngIf="fieldType.required && stringField.invalid && stringField.touched">
            {{fieldType.name}} is required</div>
        </div>

        <div class="form-group" *ngIf="fieldType.type==='PLAINSTRING' && !fieldType.hidden">
          <label for="Plainstring" class="fieldName">{{fieldType.name}}</label><span class="sp"
            *ngIf="fieldType.required">*</span>
          <div class="input-group">
            <textarea id="Plainstring" #PlainstringField="ngModel" name="Plainstring"
              [required]="fieldType.required && !fieldType.hidden" maxlength="65535" (blur)="checkStatus(null)"
              (focus)="checkStatus(fieldType.id)" [pattern]="fieldType.validationPattern" name="{{fieldType.id}}"
              [(ngModel)]=fieldType.value value="fieldType.value" class="form-control" required></textarea>
          </div>
          <div class="validation_style"
              *ngIf="!PlainstringField.valid && PlainstringField.touched && fieldType.required">{{fieldType.name}} is
              required</div>
        </div>

        <div class="form-group" *ngIf="fieldType.type==='LONGSTRING' && !fieldType.hidden">
          <label for="Longstring" class="fieldName">{{fieldType.name}}</label><span class="sp"
            *ngIf="fieldType.required">*</span>
          <div class="input-group">
            <textarea id="Longstring" #LongstringField="ngModel" name="Longstring"
              [required]="fieldType.required && !fieldType.hidden" maxlength="65535" name="fieldType.id"
              [(ngModel)]=fieldType.value value="fieldType.value" class="form-control" required></textarea>
          </div>
          <div class="validation_style" *ngIf="LongstringField.touched && !LongstringField.valid && fieldType.required">
            {{fieldType.name}} is required</div>
        </div>

        <div class="form-group" *ngIf="fieldType.type==='OPTION'&& !fieldType.hidden">
          <label for="option1" id="option1" class="fieldName">{{fieldType.name}}</label><span class="sp"
            *ngIf="fieldType.required">*</span>
          <div class="input-group">
            <select [required]="fieldType.required && !fieldType.hidden" id="{{fieldType.id}}" class="options_align" 
              #optionField="ngModel" name="{{fieldType.id}}" (change)="onOptionSelected(fieldType)"
                [(ngModel)]="fieldType.value" (ngModelChange)="onModelChange(fieldType)" required>
             <option value="">--Please select--</option> 
              <option *ngFor="let fieldOptions of fieldType.options"  [value]="fieldOptions.id">{{fieldOptions.name}}</option> 
            </select>
            <div class="validation_style" *ngIf="optionField.touched && !optionField.valid && fieldType.required">
              {{fieldType.name}} is required</div>
          </div>
        </div>


        <div class="form-group" *ngIf="fieldType.type==='MULTIPLEOPTION' && !fieldType.hidden">
          <label for="Multipleoption" id="multoption1" class="fieldName">{{fieldType.name}}</label><span class="sp"
            *ngIf="fieldType.required">*</span>
          <div class="input-group">
            <select multiple="multiple"  name="{{fieldType.id}}" id="{{fieldType.id}}" [required]="fieldType.required && !fieldType.hidden"
              #MultipleoptionField="ngModel" value="fieldType.value" class="options_align" 
              (change)="onOptionSelected(fieldType)" [(ngModel)]="fieldType.value"
              (ngModelChange)="onModelChange(fieldType)" required>
              <option value="" *ngIf="!fieldType.required">--Please select--</option>
              <option *ngFor="let options of fieldType.options"  [value]="options.id" [selected]="options.id">{{options.name}}</option>
            </select>
            <div class="validation_style" *ngIf="fieldType.value=='' && MultipleoptionField.touched && fieldType.required">{{fieldType.name}} is
              required</div>
          </div>
          
        </div>

      </div>
      <div class="fieldName" style="color: black;"> {{i18n._value['shp.helpcenter.case.maxUploadFileLable']}}
        <i class="fa fa-info" style="border-radius: 50%;"
          title="Supported file formats are txt,.doc,.docx, .xls, .xlsx, .pdf, .png, .gif, .jpeg, .jpg, .mp3, .mp4, .mov, .avi, .log, .csv, .ppt, .pptx, .p7s, .tif, .tiff, .rtf, .xml, .eml, .msg, .wav"></i>
      </div>
      <button class="file-upload-button">
        <input type="file" #fileInput name="file" title="" (click)="fileInput.value = null" (change)="handleFileInput($event)" multiple
          accept=".txt,.doc,.docx, .xls, .xlsx, .pdf, .png, .gif, .jpeg, .jpg, .mp3, .mp4, .mov, .avi, .log, .csv, .ppt, .pptx, .p7s, .tif, .tiff, .rtf, .xml, .eml, .msg, .wav" />
      </button>
    <span  class="fieldName" *ngIf="fileProgress">{{i18n._value['shp.case.file']}}</span> 
    <span  class="fieldName"   *ngIf="UploadingFile"  title="{{UploadedFileName}}">{{uploadedFileLength}} files</span> 
      <br>

      <div class="progress" *ngIf="this.status">
        <br>
        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="this.progress">
          {{this.progress}}%
        </div>
      </div>
      <div *ngIf="files!=''">
        <br>
        <table class="table-headed table-striped">
          <thead>
            <tr>
              <th class="text-left" style="padding-left: 5px;">Name</th>
              <th class="text-left">Size</th>
              <th class="text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of files">
              <td id="size_class">{{file.name}}</td>
              <td>{{file.size/1024 | number:'.1-2' }} KB</td>
              <a (click)="remove(file)">
                <i class="fa fa-trash" style="color:red;cursor:pointer; padding-top:20px;padding-left: 25px;"></i>
              </a>
            </tr>
          </tbody>
        </table>
      </div>
    
     
     <br>
      <div  class="fieldName" *ngIf="regexFile" style="color:red;">
        {{i18n._value['upload.invalid.file.name']}}
      </div>
      <div  class="fieldName" *ngIf="UploadFailedMessage" style="color:red;">
        {{i18n._value['shp.case.file.length']}}
      </div>
      <div  class="fieldName" *ngIf="!duplicateFiles" style="color:red;">
        {{i18n._value['shp.case.duplicate.file']}}
      </div>
      <div  class="fieldName" *ngIf="sizeExceededMessage" style="color:red;">
        {{i18n._value['shp.case.error.size']}}
      </div>

      <div  class="fieldName" *ngIf="UploadedFileName && UploadedFileName.length >100" style="color:red;">
        {{i18n._value['upload.error.name.exceed']}} 
      </div>

      <br>
      <div  class="fieldName" style="color:dodgerblue;text-align:right"> {{i18n._value['shp.case.file.size']}}</div>
      <span class="sp">*</span><span class="fieldName">{{i18n._value['shp.create.case.required']}}</span>
      <div class="modal-footer">
        <button type="button" (click)="closeModal()" *ngIf="closeButtonEnable" class="btn btn-warning btn" rounded="true">{{closeLabelText}}</button>
        <button type="button" class="btn btn-primary btn" [disabled]="!caseform.valid" (click)="onSubmit(caseform)" 
          rounded="true">{{this.submitButtonLabel}}</button>
      </div>
    </form>
  </div>
      </div>
</ng-template>
<!-- <div *ngIf="alert && caseCreateIsFailed" class="alertMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
  <p>{{errorMessage}}</p>
</div> -->